import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';

/**
 * TranslocoHttpLoader — loads `assets/i18n/{lang}.json` over HTTP. Both apps copy
 * `src/assets` wholesale (angular.json), so the i18n/ subdir ships in dist with
 * no build-config change. Story 25.5.
 */
@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`assets/i18n/${lang}.json`);
  }
}
